exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".simiLookup{color:red}.vehicle-lookup{margin-top:10px;margin-left:auto;margin-right:auto}.vehicle-lookup td{padding-top:5px;padding-bottom:5px;border-bottom:1px solid #000}.vehicle-lookup tbody tr:nth-child(odd){background-color:#f9f9f9}.vehicle-lookup tbody tr:nth-child(2n){background-color:var(--report-even-row)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./client/app/components/vehicle/simiLookup/simiLookup.styl
// module id = 1179
// module chunks = 0